import {
  Avatar,
  Box,
  Button,
  Card,
  Container,
  Icon,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useState } from "react";
import { BIBlue } from "../../assets/helpers";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { useTheme } from "@mui/material/styles";
const DashboardTutorial = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const { pictureUrl } = loginData;
  const {
    TEXT_HOMEPAGE = English?.HomeTutorial?.TEXT_HOMEPAGE,
    TEXT_PAGE_ONE_SUBHEADER_ONE = English?.HomeTutorial?.TEXT_PAGE_ONE_SUBHEADER_ONE,
    TEXT_PAGE_TWO_SUBHEADER_TWO = English?.HomeTutorial?.TEXT_PAGE_TWO_SUBHEADER_TWO,
    TEXT_TUTORIAL_MODAL_ANYWHERE_BTN = English?.HomeTutorial?.TEXT_TUTORIAL_MODAL_ANYWHERE_BTN,
    BUTTON_ALL = English?.HomeTutorial?.BUTTON_ALL,
    BUTTON_PROJECTS = English?.HomeTutorial?.BUTTON_PROJECTS,
    BUTTON_TRADES = English?.HomeTutorial?.BUTTON_TRADES,
    BUTTON_PRODUCTS = English?.HomeTutorial?.BUTTON_PRODUCTS,
    TEXT_FILTER_POSTS = English?.HomeTutorial?.TEXT_FILTER_POSTS,
    TEXT_PAGE_THREE_SUBHEADER = English?.HomeTutorial?.TEXT_PAGE_THREE_SUBHEADER,
    TEXT_WHAT_DO_TALK_ABOUT = English?.HomeTutorial?.TEXT_WHAT_DO_TALK_ABOUT
  } = multiLanguageData?.HomeTutorial || {};

  const [selectedTopMenu] = useState(BUTTON_ALL);
  const topMenu = [BUTTON_ALL, BUTTON_PROJECTS, BUTTON_TRADES, BUTTON_PRODUCTS];

  const theme = useTheme();
  const drawerWidth = 240;

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme?.mixins?.toolbar?.minHeight || 0}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme?.mixins?.toolbar?.minHeight || 0}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Container sx={{ padding: "0px" }} maxWidth="md">
            <Box className="main-content-Box" sx={{ p: 2 }}>
              {props.tutorialIndex === 1 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh"
                  }}>
                  <Stack sx={{ textAlign: "center", color: "white" }}>
                    <Typography variant="h6">{TEXT_HOMEPAGE}</Typography>
                    <Typography variant="subtitle1">
                      {TEXT_PAGE_ONE_SUBHEADER_ONE}
                      <br />
                      {TEXT_PAGE_TWO_SUBHEADER_TWO}
                    </Typography>
                    <Typography variant="body1">
                      <span style={{ color: BIBlue }}>
                        {" "}
                        {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                      </span>
                    </Typography>
                  </Stack>
                </Box>
              )}

              <Stack spacing={1.5}>
                <Stack spacing={2} direction={"row"} sx={{ pt: 0.1 }}>
                  {topMenu.map((menu, index) => {
                    const isSelected = menu === selectedTopMenu;
                    return (
                      <Button
                        size="large"
                        key={index}
                        label={menu}
                        variant={props.tutorialIndex === 2 ? "contained" : "text"}
                        disabled={props.tutorialIndex === 2 ? false : true}
                        color={isSelected ? "primary" : "inherit"}
                        style={{
                          textTransform: "none",
                          borderRadius: "20px"
                        }}>
                        {" "}
                        {props.tutorialIndex === 1 ? "" : menu}
                      </Button>
                    );
                  })}
                </Stack>
                {props.tutorialIndex === 2 ? (
                  <Stack sx={{ pl: 10, display: "flex", color: "white" }}>
                    <Icon>
                      <NorthWestIcon />
                    </Icon>
                    <Typography variant="h6">{TEXT_FILTER_POSTS}</Typography>
                  </Stack>
                ) : (
                  <>
                    <Card
                      sx={{ display: props.tutorialIndex === 3 ? "block" : "none" }}
                      className="pagelist-content">
                      <Stack sx={{ padding: 1, alignItems: "center" }} direction="row" spacing={1}>
                        <Avatar src={pictureUrl} alt="profile-pic" />
                        <TextField size="small" placeholder={TEXT_WHAT_DO_TALK_ABOUT} fullWidth />
                      </Stack>
                    </Card>
                    {props.tutorialIndex === 3 && (
                      <Stack sx={{ pl: 10, display: "flex", color: "white" }}>
                        <Icon>
                          <NorthWestIcon />
                        </Icon>
                        <Typography variant="h6">{TEXT_PAGE_THREE_SUBHEADER}</Typography>
                      </Stack>
                    )}
                  </>
                )}
              </Stack>
            </Box>
          </Container>
        </Box>
      </Box>
    </Modal>
  );
};

export default DashboardTutorial;
